import { useMutation, useQueryClient } from "@tanstack/react-query";

import { generateDraft } from "@/shared/writing-assistant/writing-assistant.api";
import type {
  GenerateDraftRequest,
  SurfaceDraft,
} from "@/shared/writing-assistant/writing-assistant.schema";

/// POST /workspaces/:wsId/writing-assistant/drafts. The draft itself is
/// stateless (lives only in the compose form, nothing to cache), but a
/// successful generation debits the account's shared AI credit pool, so the
/// cached entitlements (`["me","entitlements"]`) are stale the moment this
/// resolves. Invalidate so the sidebar/settings credit meter and the
/// writing-assist gate (W3) pick up the new `credits.remaining` on next read.
export function useGenerateDraft(workspaceId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation<SurfaceDraft, Error, GenerateDraftRequest>({
    mutationFn: async (input) => {
      if (!workspaceId) throw new Error("workspaceId is required");
      return generateDraft(workspaceId, input);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["me", "entitlements"] });
    },
  });
}
